import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

// Provides screen theme values to Markdown, HTML, MediaBar and VideoFeature.
const ScreenThemeContext = createContext({
  isWhiteTheme: false,
  isMarketing: false
})

export const ScreenThemeProvider = ({
  children,
  isMarketing,
  isWhiteTheme
}) => (
  <ScreenThemeContext.Provider value={{ isMarketing, isWhiteTheme }}>
    {children}
  </ScreenThemeContext.Provider>
)

ScreenThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  isMarketing: PropTypes.bool.isRequired,
  isWhiteTheme: PropTypes.bool.isRequired
}

export const useScreenTheme = () => useContext(ScreenThemeContext)
